import RippleButton from '../../../../../components/ui/RippleButton'

// Active freebet row: Expiry(date/time) | Source | Freebet Id | Stake | Play.
// Pure render — display values pre-derived in the freebets mapper; Play logic
// lives in useFreebetPlay (passed in as onPlay / playDisabled).
const FreebetRowCard = ({ data, onPlay, playDisabled }) => (
  <div className="standard-normal-bet-card-outer-container">
    <div className="standard-normal-bet-card-inner-container">
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-date">{data?.expiringDate}</div>
        <div className="standard-normal-bet-card-element-time">{data?.expiringTime}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType">{data?.sourceText}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType" title={data?.tag}>
          {data?.tagShort}
        </div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-stake">{data?.amount}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <RippleButton
          className={`standard-normal-freebet-row-play-button ${playDisabled ? 'disable-actions' : ''}`}
          onClick={() => onPlay?.(data)}
          disabled={playDisabled}
        >
          Play
        </RippleButton>
      </div>
    </div>
  </div>
)

export default FreebetRowCard
